import {useFormContext} from 'react-hook-form';
import {Grid, Typography} from '@mui/material';
import {RHFMultilingualField} from '@/shared/components/forms/theme-elements/form/RHFMultilingualField';
import {List} from './List';

export const Location = () => {
  const {
    watch,
    formState: {errors},
  } = useFormContext();

  const values = watch('menus.navigations.locations');

  return (
    <Grid>
      <Typography variant='h6' mb={2}>
        Label
      </Typography>

      <RHFMultilingualField name={'menus.navigations.locations.label'} />

      <List
        name={'menus.navigations.locations.list'}
        values={values?.list}
        errors={errors?.menus?.navigations?.locations?.list}
      />
    </Grid>
  );
};
